<template>
  <div>
    <Toast position="top-right" />
    <b-modal
      id="modal-center"
      centered
      no-close-button
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
    >
      <template #default="{ ok, cancel }">
        <div class="d-flex justify-content-between">
          <div>
            <h5 class="">Informações obrigatórias de IA</h5>
            <p class="" style="font-size: 0.85rem; color: #949494">
              Responda a pergunta obrigatória para o funcionamento da IA
            </p>
          </div>
          <i
            style="cursor: pointer"
            @click="$bvModal.hide('modal-center')"
            class="fa-solid fa-xmark text-dark"
          ></i>
        </div>

        <div class="mt-3">
          <h6 style="font-size: 0.95rem">Pergunta</h6>
          <b-form-input
            id="input-1"
            disabled
            v-model="modalCampos.pergunta"
          ></b-form-input>
        </div>
        <div class="mt-3">
          <h6 style="font-size: 0.95rem">Resposta</h6>
          <b-form-textarea
            id="textarea"
            v-model="modalCampos.resposta"
            rows="8"
            no-resize
          ></b-form-textarea>
        </div>

        <div class="d-flex justify-content-end mt-4">
          <button
            class="mr-2 p-2"
            @click="cancel()"
            style="
              border: 1px solid #472282;
              border-radius: 5px;
              color: #472282;
              cursor: pointer;
            "
          >
            Cancelar
          </button>
          <button
            class="mr-2 p-2"
            style="
              border: 1px solid #472282;
              border-radius: 5px;
              background-color: #472282;
              color: white;
            "
            @click="salvarInformacoesRecursoIA"
          >
            Salvar
          </button>
        </div>
      </template>
    </b-modal>
    <div class="card p-5">
      <div class="card-body p-4">
        <div class="aut-area-exibir">
          <div class="configuracao-menu-container">
            <div class="header-menus-container">
              <h3 style="font-weight: 600" class="mr-2">
                Informações Obrigatórias da IA
              </h3>
              <Tooltip
                message="
                  As informações obrigatórias são necessárias para o funcionamento da IA.
                  Caso não sejam preenchidas, a IA não funcionará corretamente."
              />
            </div>

            <div class="w-100">
              <div class="w-100 mt-5 d-flex justify-content-between mb-4">
                <div class="w-100 d-flex">
                  <b style="font-size: 1.1rem; width: 355px">
                    Perguntas Obrigatórias
                  </b>
                  <b style="font-size: 1.1rem"> Respostas </b>
                </div>
                <b style="font-size: 1.1rem" class="mr-4"> Editar </b>
              </div>

              <div>
                <div class="d-flex justify-content-between w-100 item-config">
                  <div class="w-100 d-flex item-info">
                    <div class="item-label">Qual o nome da IA?</div>
                    <div class="item-value">
                      {{ informacoes_recurso_ia.ira_nome_ia }}
                    </div>
                  </div>
                  <div
                    @click="
                      carregarDadosModal('Qual o nome da IA?', 'ira_nome_ia')
                    "
                    class="edit-icon"
                  >
                    <i class="fa-solid fa-pen text-dark"></i>
                  </div>
                </div>

                <div class="d-flex justify-content-between w-100 item-config">
                  <div class="w-100 d-flex item-info">
                    <div class="item-label">Qual o nome da empresa?</div>
                    <div class="item-value">
                      {{ informacoes_recurso_ia.ira_nome_empresa }}
                    </div>
                  </div>
                  <div
                    @click="
                      carregarDadosModal(
                        'Qual o nome da empresa?',
                        'ira_nome_empresa'
                      )
                    "
                    class="edit-icon"
                  >
                    <i class="fa-solid fa-pen text-dark"></i>
                  </div>
                </div>

                <div class="d-flex justify-content-between w-100 item-config">
                  <div class="w-100 d-flex item-info">
                    <div class="item-label">Qual o endereço da clínica?</div>
                    <div class="item-value ellipsis">
                      {{ informacoes_recurso_ia.ira_endereco }}
                    </div>
                  </div>
                  <div
                    @click="
                      carregarDadosModal(
                        'Qual o endereço da clínica?',
                        'ira_endereco'
                      )
                    "
                    class="edit-icon"
                  >
                    <i class="fa-solid fa-pen text-dark"></i>
                  </div>
                </div>

                <div class="d-flex justify-content-between w-100 item-config">
                  <div class="w-100 d-flex item-info">
                    <div class="item-label">
                      Quais especialidades são atendidas?
                    </div>
                    <div class="item-value ellipsis">
                      {{ informacoes_recurso_ia.ira_especialidades }}
                    </div>
                  </div>
                  <div
                    @click="
                      carregarDadosModal(
                        'Quais especialidades são atendidas?',
                        'ira_especialidades'
                      )
                    "
                    class="edit-icon"
                  >
                    <i class="fa-solid fa-pen text-dark"></i>
                  </div>
                </div>

                <div class="d-flex justify-content-between w-100 item-config">
                  <div class="w-100 d-flex item-info">
                    <div class="item-label">
                      Qual o horário de funcionamento?
                    </div>
                    <div class="item-value ellipsis">
                      {{ informacoes_recurso_ia.ira_horario_funcionamento }}
                    </div>
                  </div>
                  <div
                    @click="
                      carregarDadosModal(
                        'Qual o horário de funcionamento?',
                        'ira_horario_funcionamento'
                      )
                    "
                    class="edit-icon"
                  >
                    <i class="fa-solid fa-pen text-dark"></i>
                  </div>
                </div>

                <div class="d-flex justify-content-between w-100 item-config">
                  <div class="w-100 d-flex item-info">
                    <div class="item-label">
                      Quais os planos de saúde aceitos?
                    </div>
                    <div class="item-value ellipsis">
                      {{ informacoes_recurso_ia.ira_planos_saude }}
                    </div>
                  </div>
                  <div
                    @click="
                      carregarDadosModal(
                        'Quais os planos de saúde aceitos?',
                        'ira_planos_saude'
                      )
                    "
                    class="edit-icon"
                  >
                    <i class="fa-solid fa-pen text-dark"></i>
                  </div>
                </div>

                <div class="d-flex justify-content-between w-100 item-config">
                  <div class="w-100 d-flex item-info">
                    <div class="item-label">Qual o corpo clínico?</div>
                    <div class="item-value ellipsis">
                      {{ informacoes_recurso_ia.ira_corpo_clinico }}
                    </div>
                  </div>
                  <div
                    @click="
                      carregarDadosModal(
                        'Qual o corpo clínico?',
                        'ira_corpo_clinico'
                      )
                    "
                    class="edit-icon"
                  >
                    <i class="fa-solid fa-pen text-dark"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Swal from "sweetalert2";

import ApiService from "@/core/services/api.service";
import API_LINKS from "../automacao/api.links";

export default {
  components: {
    Toast: () => import("primevue/toast"),
    Tooltip: () => import("@/view/pages/painel/dashboard/Tooltip.vue")
  },
  data() {
    return {
      informacoes_recurso_ia: {
        ira_endereco: "",
        ira_especialidades: "",
        ira_horario_funcionamento: "",
        ira_planos_saude: "",
        ira_corpo_clinico: "",
        ira_nome_empresa: "",
        ira_nome_ia: ""
      },
      informacoes_recurso_ia_iniciais: {},
      modalCampos: {
        pergunta: "",
        resposta: ""
      }
    };
  },
  methods: {
    descartarAlteracoes() {
      if (!this.houveAlgumaMudanca) {
        return;
      }
      Swal.fire({
        title: "Descartar Alterações?",
        text: "Você tem certeza que deseja descartar as alterações?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, descartar!"
      }).then((result) => {
        if (result.value) {
          this.informacoes_recurso_ia = {
            ...this.informacoes_recurso_ia_iniciais
          };
        }
      });
    },

    async salvarInformacoesRecursoIA() {
      Swal.fire({
        title: "Salvar Alterações?",
        text: "Você tem certeza que deseja salvar as alterações?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, salvar!"
      }).then(async (result) => {
        if (result.value) {
          this.informacoes_recurso_ia[this.modalCampos.variavelEditando] =
            this.modalCampos.resposta;

          const payload = {
            informacoes_recurso_ia: {
              ...this.informacoes_recurso_ia
            }
          };
          await ApiService.put(
            API_LINKS.chatbot_informacoes_recurso_ia,
            payload
          ).then((_) => {
            this.informacoes_recurso_ia_iniciais = {
              ...this.informacoes_recurso_ia
            };
            Swal.fire({
              title: "Alterações salvas com sucesso!",
              icon: "success",
              showConfirmButton: false,
              timer: 1000
            });
            this.$bvModal.hide("modal-center");
          });
        }
      });
    },
    async buscarInformacoesRecursoIA() {
      const response = await ApiService.get(
        API_LINKS.chatbot_informacoes_recurso_ia
      );
      const informacoes_recurso_ia = response.data.informacoes_recurso_ia;
      if (!informacoes_recurso_ia) {
        const payload = {
          informacoes_recurso_ia: { ...this.informacoes_recurso_ia }
        };
        const res = await ApiService.post(
          API_LINKS.chatbot_informacoes_recurso_ia,
          payload,
          false
        );
        this.informacoes_recurso_ia = res.data.informacoes_recurso_ia;
        this.informacoes_recurso_ia_iniciais = {
          ...this.informacoes_recurso_ia
        };
      } else {
        this.informacoes_recurso_ia = informacoes_recurso_ia;
        this.informacoes_recurso_ia_iniciais = {
          ...this.informacoes_recurso_ia
        };
      }
    },
    carregarDadosModal(textoPergunta, index) {
      this.modalCampos.pergunta = textoPergunta;
      this.modalCampos.resposta = this.informacoes_recurso_ia[index];
      this.modalCampos.variavelEditando = index;
      this.$bvModal.show("modal-center");
    }
  },

  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Chatbot"
      },
      {
        title: "Opções",
        route: "/painel/chatbot/opcoes"
      }
    ]);
    const init = async () => {
      this.buscarInformacoesRecursoIA();
    };
    init();
  },
  computed: {
    houveAlgumaMudanca() {
      return (
        JSON.stringify(this.informacoes_recurso_ia) !=
        JSON.stringify(this.informacoes_recurso_ia_iniciais)
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300&display=swap");

.b-button-custom {
  width: 142px;
}

.aut-body {
  border-radius: 5px;
  background-color: #fff;
}

.aut-area-exibir {
  display: flex;
  height: 100%;
  width: 100%;
}

.aut-header {
  height: 70px;
  width: 100%;
}

.aut-camp-area {
  width: 100%;
  min-height: 500px;
}

.container-dashboard {
  border-radius: 15px;
  background-color: #fff;
  padding: 20px 10px 20px 10px;
  margin-bottom: 15px;
}

.campo-estatistica {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.dropdown-form {
  padding: 3px 0px;
  width: 170px;
  height: 45px;
}

.dropdown-form:hover {
  background-color: rgb(247, 247, 247);
}

.button-container {
  border: 1px solid #e4e6ef;
  outline: none;
  color: #e3e4ed;
  background-color: transparent;
  border-radius: 0.42rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 38px;
}
.button-container.btn i {
  padding: 0 !important;
}

::v-deep .p-chips .p-chips-multiple-container {
  width: 100% !important;
}
::v-deep .p-chips-multiple-container {
  flex-wrap: wrap !important;
  gap: 0.5rem !important;
}
/*
::v-deep .p-selectbutton .p-button {
  background: #c4c4c4 !important;
  border-color: #c4c4c4 !important;

  &.p-highlight {
    background: #ffc107 !important;
    border-color: #ffc107 !important;
    color: #212121 !important;
  }
}
*/
::v-deep .select-button-ativado .p-button {
  background: #ffffff !important;
  border-color: #ced4da !important;
  color: #000000 !important;

  &.p-highlight {
    background: #1bc5bd !important;
    border-color: #1bc5bd !important;
    color: #ffffff !important;
  }
}

::v-deep .select-button-inativado .p-button {
  background: #ffffff !important;
  border-color: #ced4da !important;
  color: #000000 !important;

  &.p-highlight {
    background: #ee2d41 !important;
    border-color: #ee2d41 !important;
    color: #ffffff !important;
  }
}

.configuracao-menu-container {
  width: 100%;

  .header-menus-container {
    display: flex;
    justify-content: start;
    align-items: center;
    margin-bottom: 24px;
    h3 {
      margin: 0;
    }
    .botoes-container {
      display: flex;
      justify-content: space-between;
    }
  }

  .flexer-container {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    min-height: 100% !important;
  }

  .flexer-col {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100% !important;

    > .form-group:first-child {
      margin-bottom: 0 !important;
    }
  }

  .lista-teste span {
    color: rgb(75, 112, 190);
    font-weight: bold;
  }
  .lista-teste i {
    color: blue;
    margin-right: 10px;
  }

  .lista-negra span {
    color: rgb(226, 77, 77);
    font-weight: bold;
  }
  .lista-negra i {
    color: red;
    margin-right: 10px;
  }
  hr {
    margin-left: 1%;
    width: 98%;
    margin-bottom: 30px;
    margin-top: -10px;
  }

  .item-config {
    padding: 5px;
    border-bottom: #e0e0e0 solid 1px;
  }

  .item-config:first-child {
    border-top: #e0e0e0 solid 1px;
  }

  .item-config:nth-child(n + 2) {
    border-top: none;
  }

  .item-config:nth-child(odd) {
    background-color: #f9f9f9;
  }

  .item-info {
    display: flex;
    width: 100%;
  }

  .item-label {
    padding-left: 0.5rem;
    display: flex;
    align-items: center;
    font-weight: 600;
    width: 350px;
  }

  .item-value {
    padding-top: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    width: 500px;
  }

  .edit-icon {
    padding: 1rem;
    margin: 0 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #e4e6ef;
    border-radius: 5px;
    min-width: 40px;
    text-align: center;
    color: #000;
    font-weight: 500;
    cursor: pointer;
  }

  .ellipsis {
  }
}
</style>
